const BurgerIcon = () => (
  <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.95312 12.8089H14.5312M1.95312 7.3203H17.0469M1.95312 1.83167H9.5" stroke="#45464E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default BurgerIcon;
